// ---------- Babel polyfills and fetch ----------
import 'babel-polyfill';
import 'isomorphic-fetch';

// ---------- Global Styles ----------
import 'styles/index.css';

// ---------- React, etc. ----------
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// Create redux store with middleware
import { store } from '_helpers';

// styled-components & design guideline
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import styles from 'styles/styles';

// ---------- Modules, Utils, Logging, etc. ----------
import registerServiceWorker, { unregister }  from './registerServiceWorker';
// import Raven from 'raven-js'; TODO: need sentryUrl
// import { sentryUrl } from 'modules/Sentry'; TODO: need sentryUrl
import injectTapEventPlugin from 'react-tap-event-plugin';

// ---------- HMR ----------
import { AppContainer } from 'react-hot-loader';

// ---------- App Mount Point ----------
import { App } from './App';

// SET UP AND TURN ON FAKE BACK END
// import { configureFakeBackend } from './_helpers';
// configureFakeBackend();

// Init Sentry for error logging TODO: need sentryUrl
// Raven.config(sentryUrl).install();
// Remove tap delay
// injectTapEventPlugin();
// Register/Unregister service worker
// registerServiceWorker();
unregister();

// Render function for App
const render = (Component) => {
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <StyledThemeProvider theme={styles}>
                    <App />
                </StyledThemeProvider>
            </Provider>
        </AppContainer>,
        document.getElementById('root'),
    );
};

// Render once
render(App);

// Webpack Hot Module Replacement
if (module.hot) {
    module.hot.accept('./App', () => {
        render(App);
    });
}



// WEBPACK FOOTER //
// ./src/index.js